<template>
  <div v-loading="loading">
    <el-card>
      <div class="box">
        <div class="boxLeft">
          <div class="text">模板预览</div>
         <div class="img">
           <img src="../../assets/images/phone.png" alt="">
           <div class="imgText">
            <div class="circle">+</div>
            <div class="select">请选择模板</div>
           </div>
           <div class="defaultImg">
            <img  :src="baseInfo.templateImgUrl" alt="">
           </div>
         </div>
         <div style="width:100%;display: flex;justify-content: center">
          <el-button style="background:#81d3f8;color:#fff;margin-top:10px;padding:0px 76px">扫码预览</el-button>
         </div>
        </div>
        <div class="boxRight">
          <div class="rightTop" style="width:100%">
            <div class="top" >行业</div>
            <div style="width:100%;margin-top:10px">
              <Swipers @activeChange="changeActive" :len="7" :itemArr="arrItem" /></div>
              <div class="lists">
                <div class="list" v-for="item,index in templateList" :key="index">
                  <div class="mask">
                    <div class="yu" @click="preView(i)">预览模板</div>
                    <div class="use" @click="useTemplate(item.templateCode,item.templateColor,item.imgUrl)">使用模板</div>
                  </div>
               <img :src="item.imgUrl" alt="">
                </div>
              </div>
              <div class="page" style="width:100%">
 <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="queryInfo.condition.currPage"
      :page-size="8"
      layout="total, prev, pager, next"
      :total="total">
    </el-pagination>
              </div>
          </div>
        </div>
      </div>
    </el-card>
    <el-dialog
  title="模板预览"
  :visible.sync="dialogShow"
  width="595px">
  <div class="box">
    <div class="left">
 <img src="https://files.axshare.com/gsc/LJ5XFZ/4f/86/fc/4f86fcc478b841d9aeeb8d863576eb45/images/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%A6%96%E9%A1%B5%E6%A8%A1%E6%9D%BF%E9%80%89%E6%8B%A9-2/u18.png?pageId=ab243d77-f84b-49d2-9194-62ce7ce650ff" alt="">
    </div>
    <div class="right">
      <div style="width:100%">
              <div class="title">餐饮外卖小众简约风首页</div>
      <div class="logotext">店教授官方</div>
      <div class="logoimg">
        <img src="../../assets/images/logoShare.png" alt="">
      </div>
      <div class="freeTag">
        <div class="free">免费</div>
        <div class="forever">永久使用</div>
      </div>
      <div class="scan">
       <div class="scantitle">
         扫描二维码预览
       </div>
       <div class="scanimg">
        <img src="https://files.axshare.com/gsc/LJ5XFZ/4f/86/fc/4f86fcc478b841d9aeeb8d863576eb45/images/%E5%B0%8F%E7%A8%8B%E5%BA%8F%E9%A6%96%E9%A1%B5%E6%A8%A1%E6%9D%BF%E9%80%89%E6%8B%A9-%E9%A2%84%E8%A7%88%E6%A8%A1%E6%9D%BF/u62.png?pageId=2f6879ae-0a65-44b2-ad07-d0da1a14d578" alt="">
       </div>
      </div>
      </div>

    </div>


  </div>
  <span slot="footer" class="dialog-footer">
    <el-button @click="dialogShow = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">使用模版</el-button>
  </span>
</el-dialog>

  </div>
</template>
<script>
import Swipers from './components/swiper.vue'
export default {
  components:{
    Swipers
  },
  data(){
    return{
      loading:true,
      baseInfo:{},
      dialogShow:false,
      arrItem:[],
      height: window.innerHeight - 106,
      templateList:[],
      total:0,
      queryInfo:{
        pageSize:8,
        currPage:1,
        condition:{
          categoryCode:''
        }
      }
    }
  },
  created(){
    this.queryType()
    this.queryTemplate()
    this.queryDefault()
  },
  methods:{
    changeActive(obj){
      this.queryInfo.condition.categoryCode=obj.categoryCode
      this.queryTemplate()
    },
    handleCurrentChange(v){
      this.queryInfo.currPage=v
      this.queryTemplate()
    },
    preView(i){
      this.dialogShow=true
    },
   async queryType(){
  let res=await this.$http.post('systemMiniTelplateCategory/queryList',{})
  let data=res.data.data
  data.unshift({categoryName:'全部',categoryCode:''})
  console.log(data)
   let arr=[]
   data.forEach((item,index)=>{
    arr.push({label:item.categoryName,code:index,categoryCode:item.categoryCode})
   })
   this.arrItem=arr
    },
    async queryDefault(){
 let res=await this.$http.post('merchantBaseInfo/queryOne',{merchantCode:localStorage.getItem('merchantCode')})
    this.baseInfo=res.data.data
    },
  async  queryTemplate(){
let res=await this.$http.post('systemMiniTelplate/list',this.queryInfo)
console.log(res)
this.loading=false
this.templateList=res.data.data.data
this.total=res.data.data.count
    },
  async  useTemplate(templateCode,templateColor,templateImgUrl){
    let data={
      merchantCode:localStorage.getItem('merchantCode'),
      templateCode,
      templateColor,
      templateImgUrl
    }
  let res=await this.$http.post('merchantBaseInfo/setTemplate',data)
    if(res.data.code==200){
      this.$message({
        type:'success',
        message:'设置成功'
      })
      this.queryDefault()
    }else{
      this.$message.error(res.data.message);
    }
    }
  }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog{
  .box{
    display: flex;
    .left{
      border: 1px solid #E4E4E4;
      img{
        display: block;
        width: 180px;
        height: 302px;
      }
    }
    .right{
      padding-top: 2px;
      margin-left: 20px;
      display: flex;
      flex: 1;
      .title{
        color: #555;
        font-size: 14px;
      }
      .logotext{
        color: #aaa;
        margin-top: 8px;
        font-size: 12px;
      }
      .logoimg{
        margin-top: 5px;
        background-color: #2DA641;
         width: 17px;
          height: 16px;
          border-radius: 2px;
        img{
          display: block;
          width: 17px;
          height: 16px;
          transform: scale(0.8);
        }
      }
      .freeTag{
        width: 112px;
        display: flex;
        margin-top: 4px;
        font-size: 12px;
        border: 1px solid #2DA641;
        border-radius: 4px;
        >div{
          padding: 0px 10px;
        }
        .free{
          background-color: #2DA641;
          color: #fff;
        }
        .forever{
          color: #2DA641;
        }
      }
      .scan{
        margin-top: 20px;
        .scantitle{
          font-size: 12px;
          color: #aaa;

        }
        .scanimg{
          display: flex;
          justify-content: center;
          img{
            width: 130px;
            display: block;
          }
        }
      }
    }
  }
}
/deep/ .el-dialog__body{
  padding-top: 16px;
}
/deep/.el-dialog__header{
  padding: 14px 20px 10px 14px;
  border-bottom: 1px solid #E4E4E4;
  .el-dialog__title{
    font-size: 16px;
    line-height: 1;
  }
  .el-dialog__headerbtn{
    top: 14px;
  }
}
.box{
  display: flex;
  .boxRight{
    display: flex;
    flex: 1;
    margin-left: 10px;
    .rightTop{
      padding-top: 10px;
      .top{
        margin-left: 6px;
        font-size: 18px;
        color: #7f7f7f;
      }
      .lists{
        margin-top: 10px;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        .list{
          position: relative;
          width: calc((100% - 30px) / 4);
          margin-bottom: 8px;
          margin-right: 10px;
          &:nth-child(4n){
            margin-right: 0;
          }
          .mask{
            transition: 0.9s;
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(0,0,0,.5);
            display: none;
            .yu,.use{
              cursor: pointer;
              user-select: none;
              width: 100px;
              height: 26px;
              text-align: center;
              line-height: 26px;
              color: #fff;
              border: 1px solid #fff;
              font-size: 12px;
              border-radius: 4px;
              margin: 0 auto; 
              margin-top: 50px;
            }
            .use{
              margin-top: 20px;
              background: rgba(21, 91, 212, 1);
              border-color: rgba(21, 91, 212, 1);
            }
          }
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .list:hover .mask{
          display: block;
        }
      }
    }
  }
  .boxLeft{
    width: 340px;
    height: 660px;
    border: 1px solid rgba(215, 215, 215, 1);
    .text{
      color: #7f7f7f;
      font-size: 18px;
      padding: 10px 10px;
    }
    .img{
      width: 240px;
      height: auto;
      position: relative;
       margin: 0 auto;
       .defaultImg{
      position: absolute;
    top: 0;
    width: 209px;
    height: 94%;
    top: 14px;
    overflow: hidden;
    left: 16px;
    border-radius: 20px;
    img{
      width: 100%;
      height: 100%;
    }
       }
      .imgText{
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100px;
        height: 100px;
        top: calc(50% - 50px);
        left: calc(50% - 50px);
        position: absolute;
        .circle{
          text-align: center;
          line-height: 34px;
          color: #fff;
          height: 40px;
          width: 40px;
          font-size: 33px;
          border-radius: 50%;
          background-color: #EBEDF0;
        }
        .select{
          font-size: 15px;
          color: #aaa;
          margin-top: 6px;
        }
      }
          img{
      width: 240px;
      display: block;
    }
    }

  }
}
// .card{
//   background-image: url("../../assets/images/templateBG.png");
//   background-size: 100% 100%;
//   background-repeat: no-repeat;
//   background-position: center;
// }
// .templateBox{
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   transform: translate(-50%,-40%);
//   width: 18%;
//   min-width: 236px;
//   height: 70%;
//   border-radius: 20px;
// }
// .phone{
//   position: absolute;
//   left: 50%;
//   top: 50%;
//   transform: translate(-50%,-40%);
//   width: 19%;
//   min-width: 239px;
//   height: 72%;
// }
// .el-icon-arrow-right{
//   font-size: 100px;
//   position: absolute;
//   right: 24%;
//   top: 50%;
//   transform: translateY(-40%);
//   opacity: 0;
// }
// .el-icon-arrow-left{
//   font-size: 100px;
//   position: absolute;
//   left: 27%;
//   top: 50%;
//   transform: translateY(-40%);
//   opacity: 0;
// }
// .submit{
//   position: absolute;
//   right: 100px;
//   top: 50px;
// }
// /deep/ .el-button--primary {
//   background-color: rgb(245, 154, 35);
//   border-color: rgb(245, 154, 35);
//   color: #fff;
// }
</style>
